const thief = Object.freeze({
  id: 'thief',
  definitionId: 'rogue:thief',
  classId: 'rogue',
  name: 'Thief',
  description: 'A resourceful Rogue who turns agility, stealth, and magic items to daring advantage.',
  selectionLevel: 3,
  features: Object.freeze([
    {
      id: 'rogue:thief:fast-hands', name: 'Fast Hands', level: 3,
      description: 'As a Bonus Action, make a Dexterity (Sleight of Hand) check to pick a lock or disarm a trap with Thieves’ Tools, or to pick a pocket. You can instead take the Utilize action or the Magic action to use a magic item that requires that action.',
      presentation: { kind: 'bonus-action', automation: 'dm-adjudicated', reason: 'Use Fast Hands on the action bar; the DM sets the subject/DC or applies a qualifying item effect.' },
      contracts: ['action-economy:bonus-action'],
    },
    {
      id: 'rogue:thief:second-story-work', name: 'Second-Story Work', level: 3,
      description: 'You gain a climb speed equal to your Speed. You can also use Dexterity instead of Strength to determine your jump distance.',
      presentation: { kind: 'passive' }, contracts: [],
    },
    {
      id: 'rogue:thief:supreme-sneak', name: 'Supreme Sneak', level: 9,
      description: 'You gain the Stealth Attack Cunning Strike option (cost 1d6): if you have the Hide action’s Invisible condition, this attack doesn’t end it if you end the turn behind Three-Quarters Cover or Total Cover.',
      presentation: { kind: 'attack-modifier', option: 'stealth-attack', cunningStrikeCost: '1d6' },
      contracts: ['rogue:cunning-strike-option'],
    },
    {
      id: 'rogue:thief:use-magic-device', name: 'Use Magic Device', level: 13,
      description: 'Your training with magic items expands your attunement and lets you draw additional reliability and charges from certain items and scrolls.',
      presentation: { kind: 'configuration', automation: 'partial', reason: 'Four attunement slots are enforced; charges and spell scrolls are handled at the table.' }, contracts: [],
    },
    {
      id: 'rogue:thief:thiefs-reflexes', name: "Thief's Reflexes", level: 17,
      description: 'You can take two turns during the first round of any combat: your first at your normal Initiative and your second at your Initiative minus 10.',
      presentation: { kind: 'passive' }, contracts: [],
    },
  ]),
});

export default thief;

